<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <!--Edit Agent-->
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:90%;"
                         role="dialog"
                         aria-labelledby="modalTitle"
                         aria-describedby="modalDescription">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AG"][obj_Group.I > 0? "EG": "AG"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm full-width">{{this.getLanguage['AG']['PC']}}<span class="required" /> : </label>
                                            <CInput :placeholder="getLanguage['AG']['PC']"
                                                    size="sm"
                                                    :value="obj_Group.PC"
                                                    class="inline inline70 uppercase"
                                                    @change="ValidatePrefixCode($event)"
                                                    maxlength="4"
                                                    :disabled="obj_Group.I > 0 "
                                                    ref="PC"></CInput>
                                            <CButton class="inline inline30" color="outline-info" size="sm" @click="GeneratePrefixCode()">
                                                <span class='plusIcon cil-loop-circular'></span>
                                                {{ getLanguage["BTN"]["GEN"] }}
                                            </CButton>
                                            <span class="ErrMsg">{{ValidationGroupErrMsg('PC')}}{{this.str_prefixError}}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{this.getLanguage['GL']['S']}} : </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_status"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['GL']['S']"
                                                        v-model="obj_Group.RS" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["PG"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup2"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                              v-model="obj_Group.PGIT"
                                                              @input="ParentGroupChange"
                                                              :disabled="obj_Group.I > 0"
                                                              ref="PGI" />
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('PGI', 'PG') }}</span>
                                        </CCol>
                                        <CCol col="2" class="form-group" v-if="bool_isAgentType">

                                            <div style="float: right" v-if="obj_Group.I > 0">
                                                <span style="float:right">
                                                    <label class="col-form-label-sm">{{this.getLanguage["FCT"]["ECF"]}}</label>
                                                </span><br />
                                                <span class="redfont" style="float:right" v-if="!obj_Group.ICT">{{this.getLanguage["GL"]["NO"]}}</span>
                                                <span class="customGreen" style="float:right" v-else>{{this.getLanguage["GL"]["YES"]}}</span>
                                            </div>
                                            <div style="float: right" v-else>
                                                <span style="float:right">
                                                    <label class="col-form-label-sm">{{this.getLanguage["FCT"]["ECF"]}}</label>
                                                </span><br />
                                                <span style="float:right">
                                                    <label class="switch">
                                                        <input type="checkbox" true-value="true" false-value="false" v-model="obj_Group.ICT" :disabled="!bool_isAgentType">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </span>
                                            </div>
                                        </CCol>

                                        <CCol col="2" class="form-group" v-if="bool_isSeniorMasterLv">
                                            <label class="col-form-label-sm">OEM<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_oem"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                        v-model="obj_Group.OEMI"
                                                        :disabled="obj_Group.I > 0"
                                                        ref="PGI" />
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('PGI', 'PG') }}</span>
                                        </CCol>


                                        <CCol col="2" class="form-group" v-else>
                                            <div style="float: right">&nbsp;</div>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm inline inline60">{{this.getLanguage["AG"]["WL"]}} :</label>
                                            <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addMyIP()">
                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["DM"]["MIP"]}}
                                            </CButton>
                                            <CInput class="inline inline60" :placeholder="getLanguage['AG']['WL']" size="sm" :value="obj_Group.WLIPS" @change="v => obj_Group.WLIPS = v"></CInput>
                                            <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addWhiteListIP()">
                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                            </CButton>
                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th>{{this.getLanguage['AG']['WL']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_Group.WhiteListIP == 0 || !obj_Group.WhiteListIP">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_Group.WhiteListIP">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removeWhiteListIP(index)'></i> <!--here Remove -->
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ data.WLIPS }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["GN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['AG']['GN']"
                                                    size="sm"
                                                    :value="obj_Group.GN"
                                                    @change="v => obj_Group.GN = v"
                                                    ref="GN"></CInput>
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('GN')}}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{ this.getLanguage["AG"]["PT"] }} (%)<span class="required" /> :
                                                <span class="float-right label-tooltip" style="padding-right:1%;">{{ this.str_ptrange }}</span>
                                            </label>
                                            <CInput :placeholder="getLanguage['AG']['PT']"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_Group.DPT, 2)"
                                                    @change="v => obj_Group.DPT = RemoveThousandSeparator(v, 2)"
                                                    :disabled="obj_Group.I > 0 && this.getUserInfo.AT != 0"
                                                    ref="PT"></CInput>
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('PT') }}</span>
                                        </CCol>
                                        <CCol v-if="obj_Group.I> 0" col="3" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{ this.getLanguage["AG"]["CR"] }} (%)<span class="required" /> :
                                                <span class="float-right label-tooltip" style="padding-right:1%;">{{ this.str_ptrange }}</span>
                                            </label>
                                            <CInput :placeholder="getLanguage['AG']['PT']"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_Group.PT, 2)"
                                                    @change="v => obj_Group.PT = RemoveThousandSeparator(v, 2)"
                                                    :disabled="obj_Group.I == 0"
                                                    ref="PT"></CInput>
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('PT') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguageOEMI(this.getUserInfo.OEMI,"AG",'SB')}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                <span class="float-right label-tooltip" style="padding-right:1%;" v-if="showAvailableBalance()">{{ this.getLanguage['AG']['SBAB']}} : {{ this.dec_availablebalance }}</span>
                                            </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency"
                                                        :placeholder="getLanguage['AG']['DC']"
                                                        @input="CurrencyChange"
                                                        v-model="obj_Group.DCI"
                                                        class="inline inline40"
                                                        :clearable="false"
                                                        :disabled="obj_Group.I > 0"
                                                        ref="DCI" />
                                            <CInput :placeholder="getLanguageOEMI(this.getUserInfo.OEMI,'AG','SB')"
                                                    size="sm"
                                                    class="inline inline60"
                                                    :value="ThousandSeparator(obj_Group.TB, getThousandCurrency ? 3 : 2)"
                                                    ref="TB"
                                                    @change="v => obj_Group.TB = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                    :disabled="obj_Group.I > 0"></CInput>
                                            <span class="ErrMsg inline inline40">{{ ValidationGroupErrMsg('DCI', 'DC') }}</span>
                                            <span class="ErrMsg inline inline60" v-if="obj_Group.I == 0">{{ ValidationGroupErrMsg('TB', 'SB') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["L"]}} :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_language_wall"
                                                        :defaultExpandLevel="1"
                                                        :placeholder="getLanguage['AG']['L']"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :disabled="!bool_isAgentType || bool_isEditGroup"
                                                        v-model="obj_Group.Language"
                                                        ref="L">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    <span class="flagClass" v-if="node.id!='0'" :class="mapLanguageFlag(node.id)"></span>
                                                    <span>{{ node.label }}</span>
                                                </div>
                                                <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                                    <span class="flagClass" v-if="node.id!='0'" :class="mapLanguageFlag(node.id)"></span>
                                                    <span>{{ node.label }}</span>
                                                </div>
                                            </treeselect>
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('L') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm full-width">{{this.getLanguage['AG']['LB']}} : </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_yesno"
                                                        :clearable="false"
                                                        :disabled="!bool_isAgentType"
                                                        :placeholder="getLanguage['AG']['LB']"
                                                        v-model="obj_Group.LB" />
                                            <!-- <label class="col-form-label-sm full-width">{{this.getLanguage['AG']['TCB']}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['AG']['DC']"
                                                        v-model="obj_Group.DCI"
                                                        class="inline inline40"
                                                        :disabled="obj_Group.I > 0" />
                                            <CInput size="sm"
                                                    class="inline inline60"
                                                    :value="ThousandSeparator(obj_Group.TCB, getThousandCurrency ? 3 : 2)"
                                                    @change="v => obj_Group.TCB = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                            <span class="ErrMsg inline inline60">{{ ValidationGroupErrMsg('TCB', 'TCB') }}</span> -->
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["C"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_currency_wall"
                                                        :defaultExpandLevel="1"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :placeholder="getLanguage['AG']['C']"
                                                        :disabled="!bool_isAgentType || bool_isEditGroup"
                                                        v-model="obj_Group.CurrencyIds"
                                                        @input="selectSupportedCurrency"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('CI', 'C') }}</span>
                                        </CCol>
                                    </CRow>
                                    <!--<CRow>
                                        <CCol col="6"></CCol>
                                        <CCol col="6" class="form-group">
                                            <div class="label-tooltip" style="padding-right:1%;" @click="toogleCustomPT">{{ customPTLabel }}</div>
                                            <div v-if="bool_customPT">
                                                <table class="custom-table custom-table-inPopUp">
                                                    <thead>
                                                        <tr>
                                                            <th>{{this.getLanguage['BAL']['C']}}</th>
                                                            <th>{{this.getLanguage["AG"]["PT"]}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(data,index) in arr_CustomPT">
                                                            <td>{{ data.C }}</td>
                                                            <td>
                                                                <input class="form-control form-control-sm"
                                                                    style="width: 60px;"
                                                                    v-model="data.PT"
                                                                    type="number"
                                                                    min="0"
                                                                    @change="changePT(data)" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </CCol>
                                    </CRow>-->
                                    <CRow>
                                        <CCol col="6">
                                            <!-- <label class="col-form-label-sm full-width">{{this.getLanguage['AG']['LB']}} : </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_yesno"
                                                        :clearable="false"
                                                        :disabled="!bool_isAgentType"
                                                        :placeholder="getLanguage['AG']['LB']"
                                                        v-model="obj_Group.LB" /> -->
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["GP"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_gameprovider"
                                                        :defaultExpandLevel="2"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :placeholder="this.utilGetDDLanguage('AG.GP')"
                                                        :disabled="!bool_isAgentType || !obj_Group.CurrencyIds || obj_Group.CurrencyIds.length == 0 || bool_isEditGroup"
                                                        v-model="obj_Group.GameProviderIds"
                                                        ref="GPI" />
                                            <span class="ErrMsg">{{ ValidationGroupErrMsg('GPI', 'GP') }}</span>
                                        </CCol>

                                    </CRow>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1)">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['H2PU'] + ' :'"
                                                        :placeholder="getLanguage['AG']['H2PU']"
                                                        size="sm"
                                                        :value="obj_Group.H2PU"
                                                        @change="v => obj_Group.H2PU = v"
                                                        ref="H2PU"
                                                        :disabled="bool_isEditGroup"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('H2PU') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["H2PCC"]}} :</label>
                                                <treeselect :multiple="true"
                                                            :options="dd_currency_h2p"
                                                            :defaultExpandLevel="1"
                                                            valueConsistsOf="LEAF_PRIORITY"
                                                            :placeholder="getLanguage['AG']['H2PCC']"
                                                            v-model="obj_Group.H2PCurrencyCodes"
                                                            :disabled="bool_isEditGroup" />
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['H2PMC'] + ' :'"
                                                        :placeholder="getLanguage['AG']['H2PMC']"
                                                        size="sm"
                                                        :value="obj_Group.H2PMC"
                                                        @change="v => obj_Group.H2PMC = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="H2PMC"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('H2PMC') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['H2PSC'] + ' :'"
                                                        :placeholder="getLanguage['AG']['H2PSC']"
                                                        size="sm"
                                                        :value="obj_Group.H2PSC"
                                                        @change="v => obj_Group.H2PSC = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="H2PSC"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('H2PSC') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForOOP('THB')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="12" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPTHMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPTHMN']"
                                                        size="sm"
                                                        :value="obj_Group.OOPTHMN"
                                                        @change="v => obj_Group.OOPTHMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPTHMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPTHMN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPTHAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPTHAS']"
                                                        size="sm"
                                                        :value="obj_Group.OOPTHAS"
                                                        @change="v => obj_Group.OOPTHAS = v"
                                                        :disabled="bool_isEditGroup"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPTHAS') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPTHSK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPTHSK']"
                                                        size="sm"
                                                        :value="obj_Group.OOPTHSK"
                                                        @change="v => obj_Group.OOPTHSK = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPTHSK"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPTHSK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForOOP('VND') & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="12" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPVIMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPVIMN']"
                                                        size="sm"
                                                        :value="obj_Group.OOPVIMN"
                                                        @change="v => obj_Group.OOPVIMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPVIMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPVIMN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPVIAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPVIAS']"
                                                        size="sm"
                                                        :value="obj_Group.OOPVIAS"
                                                        @change="v => obj_Group.OOPVIAS = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPVIAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPVIAS') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPVISK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPVISK']"
                                                        size="sm"
                                                        :value="obj_Group.OOPVISK"
                                                        @change="v => obj_Group.OOPVISK = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPVISK"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPVISK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForOOP('IDR') & !obj_Group.ICT">
                                        <div Class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="12" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPIDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPIDMN']"
                                                        size="sm"
                                                        :value="obj_Group.OOPIDMN"
                                                        @change="v => obj_Group.OOPIDMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPIDMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPIDMN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPIDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPIDAS']"
                                                        size="sm"
                                                        :value="obj_Group.OOPIDAS"
                                                        @change="v => obj_Group.OOPIDAS = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPIDAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPIDAS') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPIDSK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPIDSK']"
                                                        size="sm"
                                                        :value="obj_Group.OOPIDSK"
                                                        @change="v => obj_Group.OOPIDSK = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="OOPIDSK"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPIDSK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <!-- TEMPOLARY CLOSE OOPUSD -->
                                    <!-- <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyUSForOOP('USD') & !obj_Group.ICT">
                                        <div Class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="12" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPUSMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPUSMN']"
                                                        size="sm"
                                                        :value="obj_Group.OOPUSMN"
                                                        @change="v => obj_Group.OOPUSMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPUSMN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPUSAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPUSAS']"
                                                        size="sm"
                                                        :value="obj_Group.OOPUSAS"
                                                        @change="v => obj_Group.OOPUSAS = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPUSAS') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPUSSK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPUSSK']"
                                                        size="sm"
                                                        :value="obj_Group.OOPUSSK"
                                                        @change="v => obj_Group.OOPUSSK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPUSSK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div> -->
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForEZP('IDR')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPIDRMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPIDRMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPIDRMN"
                                                        @change="v => obj_Group.EZPIDRMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPIDRMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPIDRMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPIDRAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPIDRAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPIDRAS"
                                                        @change="v => obj_Group.EZPIDRAS = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPIDRAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPIDRAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForEZP('MYR')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPMYRMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPMYRMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPMYRMN"
                                                        @change="v => obj_Group.EZPMYRMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPMYRMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPMYRMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPMYRAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPMYRAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPMYRAS"
                                                        @change="v => obj_Group.EZPMYRAS = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPMYRAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPMYRAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <!--EZPTHB-->
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForEZP('THB')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPTHBMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPTHBMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPTHBMN"
                                                        @change="v => obj_Group.EZPTHBMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPTHBMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPTHBMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPTHBAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPTHBAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPTHBAS"
                                                        @change="v => obj_Group.EZPTHBAS = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPTHBAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPTHBAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <!--EZPVND-->
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForEZP('VND')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPVNDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPVNDMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPVNDMN"
                                                        @change="v => obj_Group.EZPVNDMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPVNDMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPVNDMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPVNDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPVNDAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPVNDAS"
                                                        @change="v => obj_Group.EZPVNDAS = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPVNDAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPVNDAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <!--EZPUSD-->
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForEZP('USD')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPUSDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPUSDMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPUSDMN"
                                                        @change="v => obj_Group.EZPUSDMN = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPUSDMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPUSDMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPUSDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPUSDAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPUSDAS"
                                                        @change="v => obj_Group.EZPUSDAS = v"
                                                        :disabled="bool_isEditGroup"
                                                        ref="EZPUSDAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPUSDAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>

                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForTUP('VND')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPVNDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPVNDMN']"
                                                        size="sm"
                                                        :value="obj_Group.TUPVNDMN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.TUPVNDMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPVNDMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPVNDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPVNDAS']"
                                                        size="sm"
                                                        :value="obj_Group.TUPVNDAS"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.TUPVNDAS = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPVNDAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForTUP('MYR')">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPMYRMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPMYRMN']"
                                                        size="sm"
                                                        :value="obj_Group.TUPMYRMN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.TUPMYRMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPMYRMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPMYRAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPMYRAS']"
                                                        size="sm"
                                                        :value="obj_Group.TUPMYRAS"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.TUPMYRAS = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPMYRAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForXFuoo('THB') & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFTHN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFTHN']"
                                                        size="sm"
                                                        :value="obj_Group.XFTHN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFTHN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFTHN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFTHK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFTHK']"
                                                        size="sm"
                                                        :value="obj_Group.XFTHK"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFTHK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFTHK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForXFuoo('VND') & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFVIN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFVIN']"
                                                        size="sm"
                                                        :value="obj_Group.XFVIN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFVIN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFVIN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFVIK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFVIK']"
                                                        size="sm"
                                                        :value="obj_Group.XFVIK"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFVIK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFVIK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForXFuoo('MYR') & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFMYRN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFMYRN']"
                                                        size="sm"
                                                        :value="obj_Group.XFMYRN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFMYRN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFMYRN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFMYRK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFMYRK']"
                                                        size="sm"
                                                        :value="obj_Group.XFMYRK"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFMYRK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFMYRK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForXFuoo('USD') & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFUSDTN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFUSDTN']"
                                                        size="sm"
                                                        :value="obj_Group.XFUSDTN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFUSDTN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFUSDTN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFUSDTK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFUSDTK']"
                                                        size="sm"
                                                        :value="obj_Group.XFUSDTK"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFUSDTK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFUSDTK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1) && checkCurrencyIDForXFuoo('IDR') & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFIDRN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFIDRN']"
                                                        size="sm"
                                                        :value="obj_Group.XFIDRN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFIDRN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFIDRN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFIDRK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFIDRK']"
                                                        size="sm"
                                                        :value="obj_Group.XFIDRK"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.XFIDRK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFIDRK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1)  & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['SPMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['SPMN']"
                                                        size="sm"
                                                        :value="obj_Group.SPMN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.SPMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SPMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['SPAK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['SPAK']"
                                                        size="sm"
                                                        :value="obj_Group.SPAK"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.SPAK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SPAK') }}</span>
                                            </CCol>

                                        </CRow>
                                    </div>


                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1)  & !obj_Group.ICT && obj_Group.PMGW != null && obj_Group.PMGW.length > 0" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <template v-if="pmgw.PGI=='20'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUMYRCN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUMYRCN']"
                                                            size="sm"
                                                            :value="obj_Group.SUMYRCN"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.SUMYRCN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUMYRCN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUMYRMN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUMYRMN']"
                                                            size="sm"
                                                            :value="obj_Group.SUMYRMN"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.SUMYRMN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUMYRMN') }}</span>
                                                </CCol>

                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUMYRAK'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUMYRAK']"
                                                            size="sm"
                                                            :value="obj_Group.SUMYRAK"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.SUMYRAK = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUMYRAK') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUMYRPOAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUMYRPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1)  && !obj_Group.ICT && obj_Group.PMGW != null && obj_Group.PMGW.length > 0" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <template v-if="pmgw.PGI=='27'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUTHBCN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUTHBCN']"
                                                            size="sm"
                                                            :value="obj_Group.SUTHBCN"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.SUTHBCN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUTHBCN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUTHBMN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUTHBMN']"
                                                            size="sm"
                                                            :value="obj_Group.SUTHBMN"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.SUTHBMN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUTHBMN') }}</span>
                                                </CCol>

                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUTHBAK'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUTHBAK']"
                                                            size="sm"
                                                            :value="obj_Group.SUTHBAK"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.SUTHBAK = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUTHBAK') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUTHBPOAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUTHBPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('VDH', 'AGS', 1)  & !obj_Group.ICT">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <CInput :label="getLanguage['AG']['SUSGDCN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['SUSGDCN']"
                                                        size="sm"
                                                        :value="obj_Group.SUSGDCN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.SUSGDCN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SUSGDCN') }}</span>
                                            </CCol>
                                            <CCol col="4" class="form-group">
                                                <CInput :label="getLanguage['AG']['SUSGDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['SUSGDMN']"
                                                        size="sm"
                                                        :value="obj_Group.SUSGDMN"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.SUSGDMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SUSGDMN') }}</span>
                                            </CCol>

                                            <CCol col="4" class="form-group">
                                                <CInput :label="getLanguage['AG']['SUSGDAK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['SUSGDAK']"
                                                        size="sm"
                                                        :value="obj_Group.SUSGDAK"
                                                        :disabled="bool_isEditGroup"
                                                        @change="v => obj_Group.SUSGDAK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SUSGDAK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <template v-if="pmgw.PGI=='44'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRCN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRCN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRPOAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>

                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <template v-if="pmgw.PGI=='53'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['918PVNDMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDSK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['918PVNDSK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDPPK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['918PVNDPPK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDMPK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['918PVNDMPK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>

                                    <div v-if="obj_Group.I==0">
                                        <div class='sectionDivider subHeaderHR'></div>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UU"]}}<span class="required" /> :</label>
                                                <CInput :placeholder="getLanguage['AG']['UU']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.U"
                                                        @change="v => obj_Group.Agent.U = v"
                                                        ref="Agent.U"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.U', 'UU') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UDN"]}}<span class="required" />:</label>
                                                <CInput :placeholder="getLanguage['AG']['UDN']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.DN"
                                                        @change="v => obj_Group.Agent.DN = v"
                                                        ref="Agent.DN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.DN', 'UDN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">
                                                    {{this.getLanguage["AG"]["UUP"]}}<span class="required" />
                                                    <div class="custom_tooltip" style="position: unset;">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext" style="width: 350px; left: unset; margin-left: -10%">{{getLanguage["AG"]["UPF"]}}</span>
                                                    </div>:
                                                </label>
                                                <CInput type="password"
                                                        :placeholder="getLanguage['AG']['UUP']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.UP"
                                                        @change="v => obj_Group.Agent.UP = v"
                                                        ref="Agent.UP"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.UP', 'UUP') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['UE'] + ' :'"
                                                        :placeholder="getLanguage['AG']['UE']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.E"
                                                        @change="v => obj_Group.Agent.E = v"
                                                        ref="Agent.E"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.E', 'UE') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UCUP"]}}<span class="required" /> :</label>
                                                <CInput type="password"
                                                        :placeholder="getLanguage['AG']['UCUP']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.CUP"
                                                        @change="v => obj_Group.Agent.CUP = v"
                                                        ref="Agent.CUP"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.CUP', 'UCUP') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['UPN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['UPN']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.PN"
                                                        @change="v => obj_Group.Agent.PN = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>

                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <template v-if="pmgw.PGI=='30'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["CPAYMI"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['CPAYMI']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["CPAYMK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['CPAYMK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='31'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["FUPMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['FUPMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["FUPAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['FUPAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='32'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["TMONEYMI"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['TMONEYMI']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["TMONEYAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['TMONEYAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='33'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SMPMC"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SMPMC']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SMPKY"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SMPKY']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='45'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SMPIDRMC"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SMPIDRMC']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SMPIDRKY"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SMPIDRKY']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='34'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRGMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDRGMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRGAS"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDRGAS']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRGK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDRGK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRDMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDRDMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRDAS"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDRDAS']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV5"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV5 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRDK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDRDK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV6"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV6 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDROMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDROMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV7"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV7 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDROAS"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDROAS']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV8"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV8 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDROK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['U2PIDROK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV9"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV9 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='39'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["LPTHBCC"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['LPTHBCC']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["LPTHBPK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['LPTHBPK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='43'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BCPDA"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BCPDA']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BCPDK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BCPDK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BCPWA"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BCPWA']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BCPWK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BCPWK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='46'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["FPGSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['FPGSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["FPGSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['FPGSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='47'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PGASV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PGASV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PGASV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PGASV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='50'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PAG"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PAG']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PDM"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PDM']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PDURL"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PDURL']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV5"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV5 = v"></CInput>
                                                </CCol>
                                                <CCol col="12" class="form-group">
                                                    <label class="col-form-label-sm mr-2">{{getLanguage["AG"]["AD3PWT"]}} ?</label>
                                                    <br />
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="obj_Group.PMGW[index].SV4.toLowerCase() == 'true'" @change="v => obj_Group.PMGW[index].SV4 = v.target.checked" :disabled="bool_isEditGroup" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PWURL"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PWURL']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV6"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV6 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PREFURL"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PREFURL']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV10"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV10 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PSBL"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PSBL']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV8"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV8 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PSBAL"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PSBAL']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV9"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV9 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PSB"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AD3PSB']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV7"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV7 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='49'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PPCI"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PPCI']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PPCS"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PPCS']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='51'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["DNCI"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['DNCI']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["DNCS"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['DNCS']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='52'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AGPSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AGPSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AGPSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AGPSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='55'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["UPSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['UPSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["UPSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['UPSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='56'">
                                            <!--Okayspay THB-->
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["OKPTHBAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['OKPTHBAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["OKPTHBSK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SMPKY']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='58'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["OKPIDRAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['OKPIDRAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["OKPIDRSK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['OKPIDRSK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='59'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["OKPVNDAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['OKPVNDAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["OKPVNDSK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['OKPVNDSK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <!--<template v-if="pmgw.PGI=='57'">-->
                                        <!--Megaspay MYR-->
                                        <!--<div class='sectionDivider subHeaderHR'></div>
        <CRow>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["MGPMYRAK"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['MGPMYRAK']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV1"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
            </CCol>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["MGPMYRSK"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['MGPMYRSK']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV2"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
            </CCol>
        </CRow>
    </template>-->
                                        <template v-if="pmgw.PGI=='60'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["VIPC"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['VIPC']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["VIPMUID"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['VIPMUID']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["VIPCK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['VIPCK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='61'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AFPGCAT"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AFPGCAT']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AFPGCAT"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AFPGCAT']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AFPPMAT"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AFPPMAT']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["AFPPMCT"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['AFPPMCT']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='63'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ONEPMK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ONEPMK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ONEPAES"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ONEPAES']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ONEPPC"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ONEPPC']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='64'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BLEUPAPI"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BLEUPAPI']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BLEUPSALT"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BLEUPSALT']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='62'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["E88PMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['E88PMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["E88PT"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['E88PT']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <!--<template v-if="pmgw.PGI=='66'">
        <div class='sectionDivider subHeaderHR'></div>
        <CRow>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["PPYPMN"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['PPYPMN']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV1"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
            </CCol>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["PPYPAPI"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['PPYPAPI']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV2"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
            </CCol>
        </CRow>
    </template>-->
                                        <template v-if="pmgw.PGI=='67'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ECPSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ECPSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ECPSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ECPSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ECPSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ECPSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='70'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYTHBSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYTHBSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYTHBSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYTHBSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='71'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYINRSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYINRSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYINRSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYINRSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='72'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYBRLSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYBRLSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYBRLSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYBRLSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='73'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYVNDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYBRLSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYVNDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYBRLSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='74'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYMYRSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYMYRSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYMYRSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['ZPAYMYRSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='75'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["UPAYSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['UPAYSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='68'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["DGPCNYSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['DGPCNYSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["DGPCNYSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['DGPCNYSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='69'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV5"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV5']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV5"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV5 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV6"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV6']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV6"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV6 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV7"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV7']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV7"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV7 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV8"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV8']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV8"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV8 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV9"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV9']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV9"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV9 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV10"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV10']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV10"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV10 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <!--<template v-if="pmgw.PGI=='76'">
        <div class='sectionDivider subHeaderHR'></div>
        <CRow>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["PNGCI"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['PNGCI']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV1"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
            </CCol>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["PNGCS"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['PNGCS']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV2"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
            </CCol>
        </CRow>
        <CRow>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["PNGAK"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['PNGAK']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV3"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
            </CCol>
            <CCol col="6" class="form-group">
                <label class="col-form-label-sm">{{getLanguage["AG"]["PNGSK"]}}:</label>
                <CInput :placeholder="getLanguage['AG']['PNGSK']"
                        size="sm"
                        :value="obj_Group.PMGW[index].SV4"
                        :disabled="bool_isEditGroup"
                        @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
            </CCol>
        </CRow>
    </template>-->
                                        <template v-if="pmgw.PGI=='77'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROUSDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROUSDSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROUSDSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROUSDSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROUSDSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROUSDSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROUSDSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROUSDSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='78'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROMYRSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROMYRSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROMYRSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROMYRSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROMYRSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROMYRSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROMYRSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROMYRSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='79'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROTHBSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROTHBSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROTHBSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROTHBSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROTHBSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROTHBSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROTHBSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROTHBSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='80'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROIDRSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROIDRSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROIDRSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROIDRSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROIDRSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROIDRSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROIDRSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROIDRSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='81'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROVNDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROVNDSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROVNDSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROVNDSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROVNDSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROVNDSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROVNDSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROVNDSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='82'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROHKDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROHKDSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROHKDSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROHKDSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROHKDSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROHKDSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROHKDSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROHKDSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='83'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBDTSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBDTSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBDTSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBDTSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBDTSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBDTSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBDTSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBDTSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='84'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBRLSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBRLSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBRLSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBRLSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBRLSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBRLSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROBRLSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROBRLSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='85'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROPHPSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROPHPSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROPHPSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROPHPSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROPHPSV3"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROPHPSV3']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PAYPROPHPSV4"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PAYPROPHPSV4']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>

                                        <template v-if="pmgw.PGI=='86'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PLMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PLMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["PLSK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['PLSK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='87'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["HUIJUCAIMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['HUIJUCAIMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["HUIJUCAISK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['HUIJUCAISK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='88'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BestPaySV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BestPaySV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["BestPaySV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['BestPaySV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='89'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["CPMNA"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['CPMNA']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["CPMNO"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['CPMNO']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["CPMSK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['CPMSK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["CPPPK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['CPPPK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["CPMPK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['CPMPK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV5"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV5 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='90'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["LNWPAYUSDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['LNWPAYUSDSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["LNWPAYUSDSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['LNWPAYUSDSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-if="pmgw.PGI=='91'">
                                            <div class='sectionDivider subHeaderHR'></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["LNWPAYHKDSV1"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['LNWPAYHKDSV1']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["LNWPAYHKDSV2"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['LNWPAYHKDSV2']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            :disabled="bool_isEditGroup"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveGroup()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!-- when a new agent was created will pop up this modal -->
        <div v-if="bool_afterAdd">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AG"]["S"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAfterAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["AG"]["GN"]}} : </label>
                                        <br>
                                        <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.BN}}</label>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["AG"]["PC"]}} :</label>
                                        <br>
                                        <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.PC}}</label>
                                    </CCol>
                                </CRow>
                                <!-- a Line -->
                                <div class='sectionDivider subHeaderHR'></div>
                                <!-- end line -->
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["AG"]["AU"]}} :</label>
                                        <br>
                                        <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.AGU}}</label>
                                        <br>
                                        <label class="col-form-label-sm">{{this.getLanguage["AG"]["AP"]}} :</label>
                                        <br>
                                        <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.AGP}}</label>
                                    </CCol>
                                </CRow>
                                <div v-if="obj_BrandDetail.CSU != null && obj_BrandDetail.CSU != ''">

                                    <div class='sectionDivider subHeaderHR'></div>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["CSU"]}} :</label>
                                            <br>
                                            <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.CSU}}</label>
                                            <br>
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["CSP"]}} :</label>
                                            <br>
                                            <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.CSP}}</label>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["MKU"]}} :</label>
                                            <br>
                                            <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.MKU}}</label>
                                            <br>
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["MKP"]}} :</label>
                                            <br>
                                            <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.MKP}}</label>
                                        </CCol>
                                    </CRow>

                                    <div class='sectionDivider subHeaderHR'></div>
                                </div>



                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <!-- end pop up -->

        <div v-if="bool_isAgentSuspendV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="height: 220px; width:50%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['AG']['ASS']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close3">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["AG"]["SSR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_suspendreason"
                                                    :placeholder="getLanguage['AG']['SSR']"
                                                    v-model="obj_Suspend.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Suspend.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['AG']['SSR']" size="sm" :value="obj_Suspend.reason2" @change="v => obj_Suspend.reason2 = v" :disabled="obj_Suspend.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationBlackListErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveSuspend()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["AG"]["MB"]}}</h2>
                        <CButton size="sm" color="outline-info" @click="addGroup()" v-if="checkModuleAccess2(constAccessType.add)"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AG"]["GN"]}} :</span>
                                <CInput size="sm" :value="arr_FV['GN']" @change="v => arr_FV['GN'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["AG"]["PG"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                  v-model="arr_FV['AGI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AG"]["PC"]}} :</span>
                                <CInput size="sm" :value="arr_FV['PC']" @change="v => arr_FV['PC'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AG"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_language"
                                            :placeholder="this.utilGetDDLanguage('AG.L')"
                                            v-model="arr_FV['L']"
                                            :limit="1"
                                            :limitText="count => `+${count}`">
                                    <div slot="value-label" slot-scope="{ node }">
                                        <span class="flagClass" v-if="node.id!='0'" :class="mapLanguageFlag(node.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                    <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                        <span v-if="node.id!='0'" class="flagClass" :class="mapLanguageFlag(node.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                </treeselect>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{ this.getLanguage["AG"]["MBL"] }}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th>{{ this.getLanguage["AG"]["GT"] }}<i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i></th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["PG"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('PGN')" :class="setSortLogo('PGN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <!--<th>{{ this.getLanguage["AG"]["PT"] }}<i @click="setSortTable('PT')" :class="setSortLogo('PT')" class="sortlogo"></i></th>-->
                                <th class="tableCtnRight">{{ this.getLanguage["AG"]["SB"] }}<i @click="setSortTable('TB')" :class="setSortLogo('TB')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["AG"]["CB"] }}<i @click="setSortTable('BL')" :class="setSortLogo('BL')" class="sortlogo"></i></th>
                                <!-- <th>{{ this.getLanguage["AG"]["TCB"] }}<i @click="setSortTable('TCB')" :class="setSortLogo('TCB')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["CCB"] }}<i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i></th> -->
                                <th>{{ this.getLanguage["AG"]["WL"] }}</th>
                                <th>{{ this.getLanguage["AG"]["L"] }}</th>
                                <th>{{ this.getLanguage["AG"]["C"] }}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th>{{ this.getLanguage["AG"]["GT"] }}<i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i></th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["PG"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('PGN')" :class="setSortLogo('PGN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <!--<th>{{ this.getLanguage["AG"]["PT"] }}<i @click="setSortTable('PT')" :class="setSortLogo('PT')" class="sortlogo"></i></th>-->
                                <th class="tableCtnRight">{{ this.getLanguage["AG"]["SB"] }}<i @click="setSortTable('TB')" :class="setSortLogo('TB')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["AG"]["CB"] }}<i @click="setSortTable('BL')" :class="setSortLogo('BL')" class="sortlogo"></i></th>
                                <!-- <th>{{ this.getLanguage["AG"]["TCB"] }}<i @click="setSortTable('TCB')" :class="setSortLogo('TCB')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["CCB"] }}<i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i></th> -->
                                <th>{{ this.getLanguage["AG"]["WL"] }}</th>
                                <th>{{ this.getLanguage["AG"]["L"] }}</th>
                                <th>{{ this.getLanguage["AG"]["C"] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Group.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Group" :class="data.ISS?'freeze-row':''">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>
                                <span id="actionBtnCol" style="display: -webkit-box;">
                                    <!-- <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete)">
                                        <i class="cil-trash" @click="removeGroup(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div> -->
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit)">
                                        <i class="cil-color-border" @click="editGroup(data.I)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && data.AT > 0 && data.IPSS == 0 && getUserInfo.AT < data.AT">
                                        <div v-if="data.ISS">
                                            <i class="cil-action-undo" @click='unSuspendAgent(data)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["USS"]}}</span>
                                        </div>
                                        <div v-else>
                                            <i class="cil-ban" @click='suspendAgent(data)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["SS"]}}</span>
                                        </div>
                                    </div>
                                    <div class="custom_tooltip">
                                        <i class="cil-cash" @click='balanceHistoryList(data.I, data.AT)'></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["HTR"]}}</span>
                                    </div>
                                    <div class="custom_tooltip">
                                        <i class="cil-browser" @click='domainList(data.I, data.AT)' v-if="data.AT==3"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["LST"]}}</span>
                                    </div>
                                </span>
                                <div class="text-danger" v-if="data.ISS" style="width: 180px; white-space: initial;">
                                    {{renderSuspendReason(data.SSR)}}
                                </div>
                            </td>
                            <td>
                                <span class="grid-line">{{ data.GN }}</span>
                                <span class="grid-line">({{ data.PC }})</span>
                            </td>
                            <!--<td>{{ data.GT }}</td>-->
                            <td>{{renderAgentType(data.AT)}}</td>
                            <td v-if="data.PPC!=''">
                                <span class="grid-line">{{ data.PGN }}</span>
                                <span class="grid-line">({{ data.PPC }})</span>
                            </td>
                            <td v-else></td>

                            <!--<td>{{ data.PT }}</td>-->
                            <td class="tableCtnRight">{{ formatNumber(data.TB, 2, data.CS) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TB - data.BL, 2, data.CS) }}</td>
                            <td><span class="grid-line" v-for="wlips in data.WhiteListIP">{{ wlips }}</span></td>
                            <!-- <td>{{ formatNumber(data.TCB, 2, data.CS) }}</td>
                            <td>{{ formatNumber(data.CBL, 2, data.CS) }}</td> -->
                            <td><span class="grid-line" v-for="lang in data.Languages">{{ lang }}</span></td>
                            <td><span class="grid-line" v-for="cur in data.Currencies">{{ cur }}</span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constStatus, constYesNo, constSuspendReasonBL } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import DateRangePicker from 'vue2-daterange-picker';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, sameAs, requiredIf, alphaNum, minLength, maxLength, between, decimal, email, minValue } from 'vuelidate/lib/validators';
    import { constAccessType, loadingFullScreen, constHouseBrand } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    function PTRangeValidation(value, vm) {
        return value >= 0 && value <= vm.MaxPT;
    }

    function validatePassword(value) {
        if (this.obj_Group.Agent.UP != null && this.obj_Group.Agent.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_Group.Agent.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                str_houtOriPrefix: "",
                bool_isSort: false, // Table Ascending Descending
                arr_FV: {
                    "GN": "",
                    "PC": "",
                    "L": [],
                    "AGI": null,
                    "DR": {
                        startDate: "",
                        endDate: ""
                    },
                }, //Filter Value
                bool_isAMV: false, // Add Modal Visible
                bool_afterAdd: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_isAgentType: false,
                bool_isSeniorMasterLv: false,
                bool_customPT: false,
                bool_houtprefixchange: false,
                bool_isEditGroup: false,
                bool_InsertAgentMembersiteConfig: false, // Insert MembersiteConfig for new Agent only
                str_prefixError: "",
                arr_Group: [],
                arr_CustomPT: [],
                obj_BrandDetail: {
                    "PRC": "",
                    "AGU": "",
                    "AGP": "",
                    "CSU": "",
                    "CSP": "",
                    "MKU": "",
                    "MKP": "",

                },

                obj_Group: {
                    "I": 0,
                    "RS": 2,
                    "GN": "",
                    "AT": "",
                    "PGI": "",
                    "PGIT": null,
                    "PC": "",
                    "PT": 0.00,
                    "DPT": 0.00,
                    "WLIPS": "",
                    "DCI": null,
                    "TB": 0.00,
                    "TCB": 0.00,
                    "CI": "",
                    "CurrencyIds": [],
                    "L": "",
                    "Language": ['en'],
                    "GPI": "",
                    "GameProviderIds": [],
                    "LB": 0,
                    "H2PU": "",
                    "H2PMC": "",
                    "H2PSC": "",
                    "H2PCC": "",
                    "H2PCurrencyCodes": null,
                    "OOPTHMN": "",
                    "OOPTHAS": "",
                    "OOPTHSK": "",
                    "OOPVIMN": "",
                    "OOPVIAS": "",
                    "OOPVISK": "",
                    "EZPIDRMN": "",
                    "EZPIDRAS": "",
                    "EZPMYRMN": "",
                    "EZPMYRAS": "",
                    "EZPTHBMN": "",
                    "EZPTHBAS": "",
                    "EZPVNDMN": "",
                    "EZPVNDAS": "",
                    "EZPUSDMN": "",
                    "EZPUSDAS": "",
                    "TUPVNDMN": "",
                    "TUPVNDAS": "",
                    "TUPMYRMN": "",
                    "TUPMYRAS": "",
                    "XFTHN": "",
                    "XFTHK": "",
                    "XFVIN": "",
                    "XFVIK": "",
                    "XFMYRN": "",
                    "XFMYRK": "",
                    "XFUSDTN": "",
                    "XFUSDTK": "",
                    "XFIDRN": "",
                    "XFIDRK": "",
                    "SPAK": "",
                    "SPMN": "",
                    "SUMYRAK": "",
                    "SUMYRMN": "",
                    "SUMYRCN": "",
                    "SUTHBAK": "",
                    "SUTHBMN": "",
                    "SUTHBCN": "",
                    "SUSGDAK": "",
                    "SUSGDMN": "",
                    "SUSGDCN": "",
                    "OOPIDMN": "",
                    "OOPIDAS": "",
                    "OOPIDSK": "",
                    "OOPUSMN": "",
                    "OOPUSAS": "",
                    "OOPUSSK": "",
                    "Agent": {
                        "I": 0,
                        "RS": 2,
                        "U": "",
                        "UP": "",
                        "CUP": "",
                        "DN": "",
                        "E": "",
                        "PN": ""
                    },
                    "WhiteListIP": [],
                    "ICT": false,
                    "MaxPT": 100,
                    "PMGW": [],
                    "InsertAgentMembersiteConfig": false
                },
                bool_groupCV: false,
                dd_template: [],
                dd_agentgroup: [],
                dd_language: [],
                dd_language_wall: [],
                dd_currency: [],
                dd_currencyNonICT: [],
                dd_currencyICT: [],
                //dd_currencycode: [],
                dd_currency_wall: [],
                dd_currency_h2p: [],
                dd_agentgroup2: [],
                dd_gameprovider: [],
                dd_status: [],
                dd_yesno: [],
                dd_oem: [],

                dec_availablebalance: 0,
                str_ptrange: "",
                constAccessType: constAccessType,
                obj_WLIPS: {
                    WLIPS: null,
                },
                customPTLabel: "",
                hasSetCurrencyLabel: false,
                bool_isAgentSuspendV: false,
                bool_suspendCV: false,
                obj_Suspend: {
                    "reason": null,
                    "reason2": ""
                },
                dd_rejectreason: [],
                constHouseBrand: constHouseBrand,
            }
        },
        validations: {
            obj_Group: {
                GN: { required },
                AT: { required },
                PGI: { required },
                PC: { required, minLength: minLength(4), maxLength: maxLength(4), alphaNum },
                //PT: { required, decimal, PTRangeValidation },
                PT: { decimal, PTRangeValidation },
                //WLIPS: { required },
                DCI: { required },
                //TB: { required, decimal, minValue: minValue(0) },
                TB: { decimal, minValue: minValue(0) },
                TCB: { required, decimal, minValue: minValue(0) },
                H2PU: { required: requiredIf(function (vm) { return this.validateH2p(); }) },
                H2PMC: { required: requiredIf(function (vm) { return this.validateH2p(); }) },
                H2PSC: { required: requiredIf(function (vm) { return this.validateH2p(); }) },
                OOPTHMN: { required: requiredIf(function (vm) { return this.validateOOPTH(); }) },
                OOPTHAS: { required: requiredIf(function (vm) { return this.validateOOPTH(); }) },
                OOPTHSK: { required: requiredIf(function (vm) { return this.validateOOPTH(); }) },
                OOPVIMN: { required: requiredIf(function (vm) { return this.validateOOPVI(); }) },
                OOPVIAS: { required: requiredIf(function (vm) { return this.validateOOPVI(); }) },
                OOPVISK: { required: requiredIf(function (vm) { return this.validateOOPVI(); }) },

                OOPIDMN: { required: requiredIf(function (vm) { return this.validateOOPID(); }) },
                OOPIDAS: { required: requiredIf(function (vm) { return this.validateOOPID(); }) },
                OOPIDSK: { required: requiredIf(function (vm) { return this.validateOOPID(); }) },
                OOPUSMN: { required: requiredIf(function (vm) { return this.validateOOPUS(); }) },
                OOPUSAS: { required: requiredIf(function (vm) { return this.validateOOPUS(); }) },
                OOPUSSK: { required: requiredIf(function (vm) { return this.validateOOPUS(); }) },

                EZPIDRMN: { required: requiredIf(function (vm) { return this.validateEZPIDR(); }) },
                EZPIDRAS: { required: requiredIf(function (vm) { return this.validateEZPIDR(); }) },
                EZPMYRMN: { required: requiredIf(function (vm) { return this.validateEZPMYR(); }) },
                EZPMYRAS: { required: requiredIf(function (vm) { return this.validateEZPMYR(); }) },
                EZPTHBMN: { required: requiredIf(function (vm) { return this.validateEZPTHB(); }) },
                EZPTHBAS: { required: requiredIf(function (vm) { return this.validateEZPTHB(); }) },
                EZPVNDMN: { required: requiredIf(function (vm) { return this.validateEZPVND(); }) },
                EZPVNDAS: { required: requiredIf(function (vm) { return this.validateEZPVND(); }) },
                EZPUSDMN: { required: requiredIf(function (vm) { return this.validateEZPUSD(); }) },
                EZPUSDAS: { required: requiredIf(function (vm) { return this.validateEZPUSD(); }) },
                TUPVNDMN: { required: requiredIf(function (vm) { return this.validateTUPVND(); }) },
                TUPVNDAS: { required: requiredIf(function (vm) { return this.validateTUPVND(); }) },
                TUPMYRMN: { required: requiredIf(function (vm) { return this.validateTUPMYR(); }) },
                TUPMYRAS: { required: requiredIf(function (vm) { return this.validateTUPMYR(); }) },
                XFTHN: { required: requiredIf(function (vm) { return this.validateXFuooTH(); }) },
                XFTHK: { required: requiredIf(function (vm) { return this.validateXFuooTH(); }) },
                XFVIN: { required: requiredIf(function (vm) { return this.validateXFuooVI(); }) },
                XFVIK: { required: requiredIf(function (vm) { return this.validateXFuooVI(); }) },
                XFMYRN: { required: requiredIf(function (vm) { return this.validateXFuooMYR(); }) },
                XFMYRK: { required: requiredIf(function (vm) { return this.validateXFuooMYR(); }) },
                XFUSDTN: { required: requiredIf(function (vm) { return this.validateXFuooUSDT(); }) },
                XFUSDTK: { required: requiredIf(function (vm) { return this.validateXFuooUSDT(); }) },
                XFIDRN: { required: requiredIf(function (vm) { return this.validateXFuooIDR(); }) },
                XFIDRK: { required: requiredIf(function (vm) { return this.validateXFuooIDR(); }) },
                SPAK: { required: requiredIf(function (vm) { return this.validateStarsPay(); }) },
                SPMN: { required: requiredIf(function (vm) { return this.validateStarsPay(); }) },


                SUMYRAK: { required: requiredIf(function (vm) { return this.validateSurePayMYR(); }) },
                SUMYRMN: { required: requiredIf(function (vm) { return this.validateSurePayMYR(); }) },
                SUMYRCN: { required: requiredIf(function (vm) { return this.validateSurePayMYR(); }) },
                SUTHBAK: { required: requiredIf(function (vm) { return this.validateSurePayTHB(); }) },
                SUTHBMN: { required: requiredIf(function (vm) { return this.validateSurePayTHB(); }) },
                SUTHBCN: { required: requiredIf(function (vm) { return this.validateSurePayTHB(); }) },
                SUSGDAK: { required: requiredIf(function (vm) { return this.validateSurePaySGD(); }) },
                SUSGDMN: { required: requiredIf(function (vm) { return this.validateSurePaySGD(); }) },
                SUSGDCN: { required: requiredIf(function (vm) { return this.validateSurePaySGD(); }) },
                CI: {
                    required: requiredIf(function (vm) {
                        if (vm.PGIT != null && vm.PGIT != "") {
                            var pgi = vm.PGIT.split("-");
                            return pgi[0] == "2";
                        }
                        return false;
                    }),
                },
                L: {
                    required: requiredIf(function (vm) {
                        if (vm.PGIT != null && vm.PGIT != "") {
                            var pgi = vm.PGIT.split("-");
                            return pgi[0] == "2";
                        }
                        return false;
                    }),
                },
                GPI: {
                    required: requiredIf(function (vm) {
                        if (vm.PGIT != null && vm.PGIT != "") {
                            var pgi = vm.PGIT.split("-");
                            return pgi[0] == "2";
                        }
                        return false;
                    }),
                },
                Agent: {
                    U: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    UP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                        minLength: value => !value || minLength(6)(value), validatePassword
                    },
                    CUP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0 && vm.UP != null && vm.UP != '';
                        }),
                        sameAsPassword: sameAs('UP')
                    },
                    DN: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    E: { email }
                },
            },
            obj_Suspend: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAgentSuspendV(newValue) {
                if (!newValue) {
                    this.cleanSuccessErrorMessage();
                }
                if (!this.bool_isAgentSuspendV && this.bool_suspendCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_groupCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            'obj_Group.PGIT': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        var agi = val.split("-");
                        this.obj_Group.AT = parseInt(agi[0]) + 1;
                    }
                }, deep: true
            },
            bool_isAgentType: function (newData, oldData) {
                if (newData == false) {
                    this.obj_Group.ICT = false;
                }
            },
            'obj_Group.ICT': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        this.obj_Group.DCI = null;
                        this.obj_Group.CurrencyIds = null;
                        if (val == 'true') {
                            this.dd_currency = [];
                            this.dd_currency.push(this.dd_currencyNonICT.find(f => f.label === 'USD'));
                            this.dd_currency_wall = this.appendSelectAllOption(this.dd_currencyICT);
                        }
                        else {
                            this.dd_currency = this.dd_currencyNonICT;
                            this.dd_currency_wall = this.appendSelectAllOption(this.dd_currencyNonICT);
                        }
                    }
                }, deep: true
            },
            getLanguage() {
                this.getGroupList();
            },
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance'
            ]),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            toogleCustomPT() {
                this.bool_customPT = !this.bool_customPT;
                if (this.bool_customPT) {
                    this.customPTLabel = this.getLanguage["AG"]["HCPTEC"];
                }
                else {
                    this.customPTLabel = this.getLanguage["AG"]["SCPTEC"];
                }
            },
            selectSupportedCurrency(value, instanceId) {
                this.getDetailDropdownList(false);
            },
            changePT() {

            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            CurrencyChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                        }
                    });
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('CRB', 'AGS', type);
            },
            showAvailableBalance() {
                return (this.obj_Group.I > 0 || (this.obj_Group.PGIT != null && this.obj_Group.PGIT != ''));
            },
            addMyIP() {
                var WLIPS_C = window.baseIP;
                var exist = false;

                this.obj_WLIPS = {
                    WLIPS: WLIPS_C
                }
                for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                    if (this.obj_Group.WhiteListIP[i].WLIPS == WLIPS_C) {
                        exist = true;
                        break;
                    }
                }
                if (exist) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else {
                    this.obj_Group.WhiteListIP.push(this.obj_WLIPS);
                }
            },
            addWhiteListIP() {
                var exist = false;

                if (this.obj_Group.WLIPS.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else if (!this.validateIP(this.obj_Group.WLIPS)) {
                    this.showErrorMessage(null, this.getLanguage["ERR"]["IIPF"], 1000);
                }
                else {
                    var WLIPS_C = this.obj_Group.WLIPS.trim();
                    this.obj_WLIPS = {
                        WLIPS: WLIPS_C
                    }
                    for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                        if (this.obj_Group.WhiteListIP[i].WLIPS == WLIPS_C) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                    }
                    else {
                        this.obj_Group.WhiteListIP.push(this.obj_WLIPS);
                        this.obj_Group.WLIPS = "";
                    }
                }
            },
            //Validate IP in IPv4 and IPv6 Format for Whitelist IP in addWhiteListIP()
            validateIP(ip) {
                return this.validateIPv4(ip) || this.validateIPv6(ip);
            },
            validateIPv4(ip) {
                const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                return ipv4Pattern.test(ip);
            },
            validateIPv6(ip) {
                const ipv6Pattern = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|(?:[a-fA-F0-9]{1,4}:){1,6}:[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,5}(?::[a-fA-F0-9]{1,4}){1,2}|(?:[a-fA-F0-9]{1,4}:){1,4}(?::[a-fA-F0-9]{1,4}){1,3}|(?:[a-fA-F0-9]{1,4}:){1,3}(?::[a-fA-F0-9]{1,4}){1,4}|(?:[a-fA-F0-9]{1,4}:){1,2}(?::[a-fA-F0-9]{1,4}){1,5}|[a-fA-F0-9]{1,4}:(?::[a-fA-F0-9]{1,4}){1,6}|:(?::[a-fA-F0-9]{1,4}){1,7}|::$/i;
                return ipv6Pattern.test(ip);
            },
            removeWhiteListIP(index) {
                this.$delete(this.obj_Group.WhiteListIP, index);
                this.$forceUpdate();
            },
            ValidationGroupErrMsg(value, langKey = "") {
                if (value == "PC" && this.str_prefixError != "") {
                    return "";
                }
                if (this.bool_groupCV) {
                    var parent = "";

                    if (value.indexOf(".") >= 0) {
                        var tempKey = value.split('.');
                        parent = tempKey[0];
                        value = tempKey[1];
                    }

                    if (langKey == "") {
                        langKey = value;
                    }

                    var validateObj = parent == "" ? this.$v.obj_Group[value] : this.$v.obj_Group[parent][value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return this.getLanguage["AG"]['ERR4'];
                        }
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.PTRangeValidation != undefined && !validateObj.PTRangeValidation) {
                        return String.format(this.getLanguage["SAPS"]["ERRBTW"], this.getLanguage["AG"][langKey], 0, this.obj_Group.MaxPT);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            ValidatePrefixCode(event) {
                var that = this;
                this.obj_Group.PC = event;
                var prefixCode = this.obj_Group.PC;
                if (prefixCode.length == 4) {
                    this.getDataApi('/api/ag/chk/0/' + prefixCode,
                        function (d, s) {
                            if (d.ERRC != "") {
                                //// prefix code duplicated
                                that.str_prefixError = String.format(that.utilGetErrorLanguage(d.ERRC), prefixCode);
                            }
                            else {
                                that.str_prefixError = "";
                            }
                        });
                }
            },
            validateH2p() {
                var v1 = this.obj_Group.H2PU
                var v2 = this.obj_Group.H2PMC
                var v3 = this.obj_Group.H2PSC
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateOOPTH() {
                var v1 = this.obj_Group.OOPTHMN
                var v2 = this.obj_Group.OOPTHAS
                var v3 = this.obj_Group.OOPTHSK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateOOPVI() {
                var v1 = this.obj_Group.OOPVIMN
                var v2 = this.obj_Group.OOPVIAS
                var v3 = this.obj_Group.OOPVISK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateOOPID() {
                var v1 = this.obj_Group.OOPIDMN
                var v2 = this.obj_Group.OOPIDAS
                var v3 = this.obj_Group.OOPIDSK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateOOPUS() {
                var v1 = this.obj_Group.OOPUSMN
                var v2 = this.obj_Group.OOPUSAS
                var v3 = this.obj_Group.OOPUSSK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateEZPIDR() {
                var v1 = this.obj_Group.EZPIDRMN
                var v2 = this.obj_Group.EZPIDRAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPMYR() {
                var v1 = this.obj_Group.EZPMYRMN
                var v2 = this.obj_Group.EZPMYRAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPTHB() {
                var v1 = this.obj_Group.EZPTHBMN
                var v2 = this.obj_Group.EZPTHBAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPVND() {
                var v1 = this.obj_Group.EZPVNDMN
                var v2 = this.obj_Group.EZPVNDAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPUSD() {
                var v1 = this.obj_Group.EZPUSDMN
                var v2 = this.obj_Group.EZPUSDAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateTUPVND() {
                var v1 = this.obj_Group.TUPVNDMN
                var v2 = this.obj_Group.TUPVNDAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateTUPMYR() {
                var v1 = this.obj_Group.TUPMYRMN
                var v2 = this.obj_Group.TUPMYRAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooTH() {
                var v1 = this.obj_Group.XFTHN
                var v2 = this.obj_Group.XFTHK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooVI() {
                var v1 = this.obj_Group.XFVIN
                var v2 = this.obj_Group.XFVIK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooMYR() {
                var v1 = this.obj_Group.XFMYRN
                var v2 = this.obj_Group.XFMYRK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooUSDT() {
                var v1 = this.obj_Group.XFUSDTN
                var v2 = this.obj_Group.XFUSDTK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooIDR() {
                var v1 = this.obj_Group.XFIDRN
                var v2 = this.obj_Group.XFIDRK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateStarsPay() {
                var v1 = this.obj_Group.SPAK
                var v2 = this.obj_Group.SPMN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateSurePaySGD() {
                var v1 = this.obj_Group.SUSGDAK
                var v2 = this.obj_Group.SUSGDMN
                var v3 = this.obj_Group.SUSGDCN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateSurePayMYR() {
                var v1 = this.obj_Group.SUMYRAK
                var v2 = this.obj_Group.SUMYRMN
                var v3 = this.obj_Group.SUMYRCN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateSurePayTHB() {
                var v1 = this.obj_Group.SUTHBAK
                var v2 = this.obj_Group.SUTHBMN
                var v3 = this.obj_Group.SUTHBCN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            GeneratePrefixCode() {
                var that = this;
                if (that.str_houtOriPrefix != "") {
                    that.obj_Group.PC = that.str_houtOriPrefix;
                } else {

                    this.getDataApi(`/api/ag/pc`,
                        function (d, s) {
                            if (s) {
                                that.obj_Group.PC = d.D;
                            }
                        });
                }
            },
            ParentGroupChange(value) {
                this.bool_fullLoading = false;
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-");
                }

                if (agi[0] == "2") {
                    this.bool_isAgentType = true;
                    this.bool_isSeniorMasterLv = false;
                }
                else if (agi[0] == "0") {
                    this.bool_isSeniorMasterLv = true;
                    this.bool_isAgentType = false;
                }
                else {
                    this.bool_isAgentType = false;
                    this.bool_isSeniorMasterLv = false;
                }

                this.obj_Group.CI = "";
                this.obj_Group.CurrencyIds = [];
                this.obj_Group.L = "";
                this.obj_Group.Language = ['en'];
                this.obj_Group.GPI = "";
                this.obj_Group.GameProviderIds = [];

                if (this.obj_Group.I == 0) {
                    this.getDataApi(`/api/ag/gb/${agi[1]}/0`,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.dec_availablebalance = that.formatNumber(d.D.TB - d.D.BL, 2, d.D.CS);
                                that.str_ptrange = "0.00% - " + d.D.PT.toFixed(2) + "%";
                                that.obj_Group.MaxPT = d.D.PT;
                                that.obj_Group.OEMI = d.D.OEMI;

                                if (d.D.OEMI == 2) {
                                    if (that.obj_Group.I == 0) {
                                        that.obj_Group.PC = d.D.PC;
                                        that.str_houtOriPrefix = d.D.PC;
                                    }
                                    if (!(agi[0] == "1")) {
                                        that.obj_Group.DCI = d.D.CI;
                                        if (that.bool_isAgentType) {
                                            that.obj_Group.CurrencyIds = [d.D.CI];
                                        }

                                    }

                                }
                                else {
                                    that.str_houtOriPrefix = "";
                                }

                            }
                        });
                    this.getDetailDropdownList(false);
                }
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_groupCV = false;
                this.bool_InsertAgentMembersiteConfig = false; //Indicate not new agent, dont insert Membersite Config
            },
            closeAfterAdd() {
                this.bool_afterAdd = !this.bool_afterAdd;
                this.bool_InsertAgentMembersiteConfig = false; //Indicate not new agent, dont insert Membersite Config
            },
            ctrPage(newPage, inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGroupList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getGroupList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getGroupList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;

                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_language = d.dropdownlist;
                            that.dd_language_wall = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });

                if (this.getUserInfo.AT == 0) {
                    this.getDataApi(`/api/dd/oem`,
                        function (d, s) {
                            if (s) {
                                that.dd_oem = d.dropdownlist;
                            }
                        });
                }

                this.getAgentGroupDropdown();
            },
            getAgentGroupDropdown() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            // var cloneParentGroup = that.deepClone(d.dropdownlist);

                            // //// list filter only push in child group, do not include own group
                            // if (cloneParentGroup != null && cloneParentGroup.length > 0) {
                            //     that.dd_agentgroup = [];
                            //     for (var i = 0; i < cloneParentGroup.length; i++) {
                            //         if (cloneParentGroup[i].children != null && cloneParentGroup[i].children.length > 0) {
                            //             for (var j = 0; j < cloneParentGroup[i].children.length; j++) {
                            //                 that.dd_agentgroup.push(cloneParentGroup[i].children[j]);
                            //             }
                            //         }
                            //     }
                            // }

                            that.dd_agentgroup2 = d.dropdownlist;

                            if (that.dd_agentgroup2.length > 0) {
                                that.dd_agentgroup2.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                if (item.children && item.children.length > 0) {
                    var agi = item.id.split("-");
                    if (agi[0] == "2") {
                        item.children.splice(0, item.children.length);
                        item.children = null;
                        delete item.children;
                    }
                    else {
                        item.children.forEach(this.disableAgentGroupParent);
                    }
                }
            },
            getDetailDropdownList(bool_showForm) {
                var that = this;
                var int_loaded = 0;
                this.dd_gameprovider = [];
                this.dd_status = [{ id: '1', label: this.getLanguage['GL']['DISB'] }, { id: '2', label: this.getLanguage['GL']['ENB'] }];
                this.dd_yesno = [{ id: '1', label: this.getLanguage['GL']['YES'] }, { id: '0', label: this.getLanguage['GL']['NO'] }];

                if (this.dd_template.length == 0) {
                    this.getDataApi(`/api/dd/tp`,
                        function (d, s) {
                            if (s) {
                                that.dd_template = d.dropdownlist;
                            }

                            int_loaded++;

                            if (int_loaded == 4 && bool_showForm) {
                                that.bool_fullLoading = false;
                                that.bool_isAMV = true;
                            }
                        });
                }
                else if (bool_showForm) {
                    int_loaded++;

                    if (int_loaded == 4) {
                        this.bool_fullLoading = false;
                        this.bool_isAMV = true;
                    }
                }

                var agi = 0;
                if (this.obj_Group.I == 0 && this.obj_Group.PGIT != null) {
                    agi = this.obj_Group.PGIT.split("-")[1];
                }
                else if (this.obj_Group.PGIT == null) {
                    agi = 0;
                }
                else {
                    agi = this.obj_Group.I;
                }

                if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                    this.getDataApi('/api/dd/game/provbycur/0/1/' + agi + '/' + this.obj_Group.CurrencyIds.join(','),
                        function (d, s) {
                            if (s && d.dropdownlist && d.dropdownlist.length > 0) {
                                for (var j = 0; j < d.dropdownlist.length; j++) {
                                    if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                        for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                            if (d.dropdownlist[j].children[l].label in that.getLanguage['GP']) {
                                                d.dropdownlist[j].children[l].label = that.getLanguage['GP'][d.dropdownlist[j].children[l].label];
                                                if (that.constHouseBrand.includes(d.dropdownlist[j].children[l].id)) {
                                                    d.dropdownlist[j].children[l].isDisabled = true;
                                                    that.obj_Group.GameProviderIds.push(d.dropdownlist[j].children[l].id)


                                                }
                                            }
                                        }

                                    }
                                }
                                that.obj_Group.GameProviderIds = _.uniq(that.obj_Group.GameProviderIds);
                                that.dd_gameprovider = that.appendSelectAllOption(d.dropdownlist);
                            }

                            int_loaded++;

                            if (int_loaded == 4 && bool_showForm) {
                                that.bool_fullLoading = false;
                                that.bool_isAMV = true;
                            }
                        });
                }
                else if (bool_showForm) {
                    int_loaded++;

                    if (int_loaded == 4) {
                        this.bool_fullLoading = false;
                        this.bool_isAMV = true;
                    }
                }

                if (this.dd_currency.length == 0) {
                    this.getDataApi('/api/dd/cur/0',
                        function (d, s) {
                            if (s) {
                                //that.dd_currency = d.dropdownlist;
                                //that.dd_currencycode = [];
                                //that.dd_currency_wall = that.appendSelectAllOption(d.dropdownlist);

                                if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                    for (var i = 0; i < d.dropdownlist.length; i++) {
                                        if (d.dropdownlist[i].ICT == true)
                                            that.dd_currencyICT.push(d.dropdownlist[i]);
                                        else
                                            that.dd_currencyNonICT.push(d.dropdownlist[i]);
                                    }
                                }

                                if (that.obj_Group.ICT) {
                                    that.dd_currency = [];
                                    that.dd_currency.push(that.dd_currencyNonICT.find(f => f.label === 'USD'));
                                    that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyICT);
                                }
                                else {
                                    that.dd_currency = that.dd_currencyNonICT;
                                    that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyNonICT);
                                }
                                //if (that.dd_currency != null && that.dd_currency.length > 0) {
                                //for (var i = 0; i < that.dd_currency.length; i++) {
                                //that.dd_currencycode[i] = that.dd_currency;
                                //that.dd_currencycode[i].id = that.dd_currencycode[i].label;
                                //}
                                //}

                                //if (!that.hasSetCurrencyLabel) {
                                //    for (var i = 0; i < that.arr_CustomPT.length; i++) {
                                //        that.arr_CustomPT[i].C = that.getCurrencyLabel(that.arr_CustomPT[i])
                                //    }
                                //}
                            }
                            int_loaded++;

                            if (int_loaded == 4 && bool_showForm) {
                                that.bool_fullLoading = false;
                                that.bool_isAMV = true;
                            }
                        });

                    //this.setSelectedCurrency();
                }
                else if (bool_showForm) {
                    int_loaded++;

                    if (int_loaded == 4) {
                        this.bool_fullLoading = false;
                        this.bool_isAMV = true;
                    }
                }

                if (this.dd_currency_h2p.length == 0) {
                    this.getDataApi('/api/dd/cur-pg/1',
                        function (d, s) {
                            if (s) {
                                that.dd_currency_h2p = that.appendSelectAllOption(d.dropdownlist);
                            }

                            int_loaded++;

                            if (int_loaded == 4 && bool_showForm) {
                                that.bool_fullLoading = false;
                                that.bool_isAMV = true;
                            }
                        });
                }
                else if (bool_showForm) {
                    int_loaded++;

                    if (int_loaded == 4) {
                        this.bool_fullLoading = false;
                        this.bool_isAMV = true;
                    }
                }
            },
            getGroupList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += ("f.GN=" + this.arr_FV["GN"] + "&f.PC=" + this.arr_FV["PC"] + "&f.L_csv=" + this.arr_FV["L"] + "&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]));

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }

                }

                this.getDataApi(`/api/ag/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_Group = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            addGroup() {
                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                //this.getDetailDropdownList(true);
                this.bool_isAgentType = false;
                this.bool_isSeniorMasterLv = false;
                this.bool_isEditGroup = false;
                this.bool_InsertAgentMembersiteConfig = true //Indicate agent is newly created.
                //this.bool_customPT = false;
                //this.customPTLabel = this.getLanguage["AG"]["SCPTEC"];
                //this.hasSetCurrencyLabel = false;

                this.obj_Group = {
                    "I": 0,
                    "RS": 2,
                    "GN": "",
                    "AT": "",
                    "PGI": "",
                    "PGIT": null,
                    "PC": "",
                    "PT": null,
                    "DPT": null,
                    "WLIPS": "",
                    "DCI": null,
                    "TB": null,
                    "TCB": 0.00,
                    "CI": "",
                    "CurrencyIds": [],
                    "L": "",
                    "Language": ['en'],
                    "GPI": "",
                    "GameProviderIds": [],
                    "LB": 0,
                    "H2PU": "",
                    "H2PMC": "",
                    "H2PSC": "",
                    "H2PCC": "",
                    "OOPTHMN": "",
                    "OOPTHAS": "",
                    "OOPTHSK": "",
                    "OOPVIMN": "",
                    "OOPVIAS": "",
                    "OOPVISK": "",
                    "EZPIDRMN": "",
                    "EZPIDRAS": "",
                    "EZPMYRMN": "",
                    "EZPMYRAS": "",
                    "EZPTHBMN": "",
                    "EZPTHBAS": "",
                    "EZPVNDMN": "",
                    "EZPVNDAS": "",
                    "EZPUSDMN": "",
                    "EZPUSDAS": "",
                    "TUPVNDMN": "",
                    "TUPVNDAS": "",
                    "TUPMYRMN": "",
                    "TUPMYRAS": "",
                    "XFTHN": "",
                    "XFTHK": "",
                    "XFVIN": "",
                    "XFVIK": "",
                    "XFMYRN": "",
                    "XFMYRK": "",
                    "XFUSDTN": "",
                    "XFUSDTK": "",
                    "XFIDRN": "",
                    "XFIDRK": "",
                    "SPAK": "",
                    "SPMN": "",
                    "SUMYRAK": "",
                    "SUMYRMN": "",
                    "SUMYRCN": "",
                    "SUTHBAK": "",
                    "SUTHBMN": "",
                    "SUTHBCN": "",
                    "SUSGDAK": "",
                    "SUSGDMN": "",
                    "SUSGDCN": "",
                    "OOPIDMN": "",
                    "OOPIDAS": "",
                    "OOPIDSK": "",
                    "OOPUSMN": "",
                    "OOPUSAS": "",
                    "OOPUSSK": "",
                    "H2PCurrencyCodes": null,
                    "Agent": {
                        "I": 0,
                        "RS": 2,
                        "U": "",
                        "UP": "",
                        "CUP": "",
                        "DN": "",
                        "E": "",
                        "PN": ""
                    },
                    "WhiteListIP": [],
                    "ICT": false,
                    "hout_PrefixChange": false,
                    "MaxPT": 100
                };
                //this.addMyIP();
                this.getDetailDropdownList(true);
                if (this.dd_agentgroup2[0].children == undefined) {
                    this.obj_Group.PGIT = this.dd_agentgroup2[0].id;
                    this.ParentGroupChange(this.obj_Group.PGIT);
                }
            },
            removeGroup(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/ag/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getAgentGroupDropdown();
                                    that.getGroupList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            domainList(id, agentType) {
                this.$router.push("/AGS/CRD?agi=" + agentType + "-" + id);
            },
            getCurrencyLabel(id) {
                if (this.dd_currency.length > 0 && id) {
                    for (var i = 0; i < this.dd_currency.length; i++) {
                        if (this.dd_currency[i].id == id) {
                            id = this.dd_currency[i].label;
                            break;
                        }
                    }
                }

                return id;
            },
            editGroup(id) {
                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.bool_isEditGroup = true;
                this.bool_InsertAgentMembersiteConfig = false; //Indicate agent is newly created.
                var that = this;
                //this.getDetailDropdownList(false);

                this.getDataApi(`/api/ag/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        //that.bool_customPT = false;
                        //that.customPTLabel = that.getLanguage["AG"]["SCPTEC"];
                        //that.hasSetCurrencyLabel = false;

                        if (s) {
                            that.obj_Group = Object.assign(that.obj_Group, d.D);
                            that.bool_isAgentType = that.obj_Group.AT == "3" ? true : false;
                            that.bool_isSeniorMasterLv = that.obj_Group.AT == "1" ? true : false;
                            if (that.obj_Group.PT != null && that.obj_Group.PT > 0) {
                                that.obj_Group.PT = that.obj_Group.PT.toFixed(2);
                            }
                            else {
                                that.obj_Group.PT = "0.00";
                            }
                            if (that.obj_Group.DPT != null && that.obj_Group.DPT > 0) {
                                that.obj_Group.DPT = that.obj_Group.DPT.toFixed(2);
                            }
                            else {
                                that.obj_Group.DPT = "0.00";
                            }

                            if (that.obj_Group.TB != null && that.obj_Group.TB > 0) {
                                that.obj_Group.TB = that.obj_Group.TB.toFixed(2);
                            }
                            else {
                                that.obj_Group.TB = "0.00";
                            }

                            if (that.obj_Group.TCB != null && that.obj_Group.TCB > 0) {
                                that.obj_Group.TCB = that.obj_Group.TCB.toFixed(2);
                            }
                            else {
                                that.obj_Group.TCB = "0.00";
                            }

                            if (that.obj_Group.ICT) {
                                that.dd_currency = [];
                                that.dd_currency.push(that.dd_currencyNonICT.find(f => f.label === 'USD'));
                                that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyICT);
                            }
                            else {
                                that.dd_currency = that.dd_currencyNonICT;
                                that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyNonICT);
                            }

                            //that.arr_CustomPT = [];
                            if (that.obj_Group.CI != null && that.obj_Group.CI.length > 0) {
                                that.obj_Group.CurrencyIds = that.obj_Group.CI.split(',');
                                //for (var i = 0; i < that.obj_Group.CurrencyIds.length; i++) {
                                //    var c = that.getCurrencyLabel(that.obj_Group.CurrencyIds[i]);
                                //    if (c != that.obj_Group.CurrencyIds[i]) {
                                //        that.hasSetCurrencyLabel = true;
                                //    }

                                //    that.arr_CustomPT.push({
                                //        PT: 0,
                                //        C: c,
                                //        CI: that.obj_Group.CurrencyIds[i]
                                //    });
                                //}
                            }
                            else {
                                that.obj_Group.CurrencyIds = null;
                            }

                            that.getDetailDropdownList(false);

                            if (that.obj_Group.H2PCC != null && that.obj_Group.H2PCC.length > 0) {
                                that.obj_Group.H2PCurrencyCodes = that.obj_Group.H2PCC.split(',');
                            }
                            else {
                                that.obj_Group.H2PCurrencyCodes = null;
                            }

                            if (that.obj_Group.L != null && that.obj_Group.L.length > 0) {
                                that.obj_Group.Language = that.obj_Group.L.split(',');
                            }
                            else {
                                that.obj_Group.Language = null;
                            }

                            if (that.obj_Group.GPI != null && that.obj_Group.GPI.length > 0) {
                                that.obj_Group.GameProviderIds = that.obj_Group.GPI.split(',');
                            }
                            else {
                                that.obj_Group.GameProviderIds = that.HouseBrand;
                            }

                            that.obj_Group.Agent = {
                                "I": -1,
                                "UP": "",
                                "CUP": ""
                            };

                            that.dec_availablebalance = that.formatNumber(that.obj_Group.TB - that.obj_Group.BL, 2, d.D.CS);

                            that.CurrencyChange(that.obj_Group.DCI);

                            that.obj_Group.WhiteListIP = [];
                            if (that.obj_Group.WLIPS != "") {
                                var WLIPS_C = that.obj_Group.WLIPS;
                                that.obj_Group.WLIPS = "";
                                var WLIPS_CARRY = WLIPS_C.split(',');
                                for (var i = 0; i < WLIPS_CARRY.length; i++) {
                                    that.obj_WLIPS = {
                                        WLIPS: WLIPS_CARRY[i]
                                    }
                                    that.obj_Group.WhiteListIP.push(that.obj_WLIPS);
                                }
                            }
                            /*that.ParentGroupChange(that.obj_Group.PGIT);*/
                            // get parent maxPT
                            var this1 = that;
                            that.getDataApi(`/api/ag/gb/${that.obj_Group.PGI}/0`,
                                function (d, s) {
                                    if (s) {
                                        this1.dec_availablebalance = this1.formatNumber(d.D.TB - d.D.BL, 2, d.D.CS);
                                        this1.str_ptrange = "0.00% - " + d.D.PT.toFixed(2) + "%";
                                        this1.obj_Group.MaxPT = d.D.PT;
                                    }
                                });

                            that.bool_isAMV = true;

                            //that.setSelectedCurrency();
                        }
                    });

            },
            saveGroup() {
                if (this.obj_Group.I == 0) {
                    this.obj_Group.PT = this.obj_Group.DPT;
                }

                if (this.obj_Group.PGIT != null && this.obj_Group.PGIT.length > 0) {
                    var agi = this.obj_Group.PGIT.split("-");
                    this.obj_Group.PGI = agi[1];
                    this.obj_Group.AT = parseInt(agi[0]) + 1;
                }

                if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                    this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',');
                }

                if (this.obj_Group.H2PCurrencyCodes != null && this.obj_Group.H2PCurrencyCodes.length > 0) {
                    this.obj_Group.H2PCC = this.obj_Group.H2PCurrencyCodes.join(',');
                }

                if (this.obj_Group.Language != null && this.obj_Group.Language.length > 0) {
                    this.obj_Group.L = this.obj_Group.Language.join(',');
                }

                if (this.obj_Group.GameProviderIds != null && this.obj_Group.GameProviderIds.length > 0) {
                    this.obj_Group.GPI = this.obj_Group.GameProviderIds.join(',');
                }

                if (this.obj_Group.WhiteListIP != null && this.obj_Group.WhiteListIP.length > 0) {
                    this.obj_Group.WLIPS = "";
                    for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                        if (i != 0) {
                            this.obj_Group.WLIPS += ",";
                        }
                        this.obj_Group.WLIPS += this.obj_Group.WhiteListIP[i].WLIPS;
                    }
                }
                if (this.str_houtOriPrefix == this.obj_Group.PC) {
                    this.obj_Group.hout_PrefixChange = true;
                } else {
                    this.obj_Group.hout_PrefixChange = false;
                }
                // Check if need to insert Agent Membersite Config (New agent only)
                if (this.bool_InsertAgentMembersiteConfig) {
                    this.obj_Group.InsertAgentMembersiteConfig = true;
                } else {
                    this.obj_Group.InsertAgentMembersiteConfig = false;
                }
                //// check the require field
                this.bool_groupCV = true;
                this.$v.obj_Group.$touch();
                if (!this.$v.obj_Group.$error && this.str_prefixError == "") {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;

                    this.postDataApi(`/api/ag/s`, this.obj_Group,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.getAgentGroupDropdown();

                                that.getGroupList();
                                that.getFromSystemBalance();
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                }
                else {
                    //get the object for validating.
                    const validation = this.$v["obj_Group"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            getFromSystemBalance() {
                var that = this;
                this.getDataApi(`/api/ag/gcag`,
                    function (d, s) {
                        if (s) {
                            that.setCurrencySymbol(d.D.CS);
                            that.setSystemBalance(d.D.SB);
                            that.setCreditBalance(d.D.CB2);
                        }
                    });
            },
            popUpAgentDetailModal(data) {
                if (data && data.IN) {
                    this.obj_BrandDetail = Object.assign(this.obj_BrandDetail, data);
                    this.bool_afterAdd = true;
                }
            },
            balanceHistoryList(id, agentType) {
                this.$router.push("/AGS/BalanceHistory?agi=" + agentType + "-" + id);
            },

            clearDateRangeFilter() {
                this.arry_FV.DR = {
                    startDate: "",
                    endDate: ""
                };
            },
            checkCurrencyIDForOOP(cname) {
                var cid = this.dd_currency.find(f => f.label === cname).id
                return this.obj_Group.CI.split(',').includes(cid);
            },
            checkCurrencyIDForEZP(cname) {
                var cid = this.dd_currency.find(f => f.label === cname).id
                return this.obj_Group.CI.split(',').includes(cid);
            },
            checkCurrencyIDForTUP(cname) {
                var cid = this.dd_currency.find(f => f.label === cname).id
                return this.obj_Group.CI.split(',').includes(cid);
            },
            checkCurrencyIDForXFuoo(cname) {
                var cid = this.dd_currency.find(f => f.label === cname).id
                return this.obj_Group.CI.split(',').includes(cid);
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            close3() {
                this.bool_isAgentSuspendV = !this.bool_isAgentSuspendV;
                this.bool_suspendCV = false;
            },
            suspendAgent(d) {
                this.bool_suspendCV = false;
                this.dd_suspendreason = constSuspendReasonBL;
                this.obj_suspend = {
                    RM: null,
                    _d: d
                };
                this.obj_Suspend = {
                    "reason": null,
                    "reason2": ""
                },

                    this.bool_isAgentSuspendV = true;
            },
            saveSuspend() {
                this.bool_suspendCV = true;

                var suspendreason = this.obj_Suspend.reason == 999 ? this.obj_Suspend.reason2 : this.obj_Suspend.reason;

                if (suspendreason != "" && suspendreason != null) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    var dt = {
                        I: this.obj_suspend._d.I,
                        UTS: this.obj_suspend._d.UTS,
                        SSR: suspendreason,
                        AGI: this.obj_suspend._d.AGI,
                        ICI: 0
                    };
                    this.postDataApi(`/api/ag/spa`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '30em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt['ICI'] = 1;
                                            that.postDataApi(`/api/ag/spa`, dt,
                                                function (d, s) {
                                                    that.bool_fullLoading = false;
                                                    if (s) {
                                                        that.bool_isAgentSuspendV = false;
                                                        that.getGroupList();
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.bool_isAgentSuspendV = false;
                                    that.getGroupList();
                                }
                            }
                        });
                }
            },
            unSuspendAgent(d) {
                this.$fire({
                    title: this.getLanguage["AG"]["CUSS"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/ag/uspa`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getGroupList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            ValidationBlackListErrMsg(value) {
                if (this.bool_suspendCV) {
                    var validateObj = this.$v.obj_Suspend[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["AG"]["SSR"]);
                    }
                }
            },
            renderSuspendReason(suspendReason) {
                const found = constSuspendReasonBL.some(el => el.id === suspendReason);

                if (found) {
                    for (var d of constSuspendReasonBL) {
                        if (d.id == suspendReason) {
                            suspendReason = d.label;
                        }
                    }
                }

                return suspendReason;
            },
            renderAgentType(int_agentType) {
                switch (int_agentType) {
                    case 1:
                        return this.getLanguage['AG']['SM'];
                        break;
                    case 2:
                        return this.getLanguage['AG']['MA'];
                        break;
                    default:
                        return this.getLanguage['AG']['A'];
                        break;
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.CRB';
            this.getDropdownList();
            this.setThousandCurrency(false);

            var parameters = this.$route.query;
            if (parameters.agi !== undefined) {
                this.arr_FV.AGI = parameters.agi;
            }

            if (parameters.pc !== undefined) {
                this.arr_FV.PC = parameters.pc;
            }

            this.getGroupList();
        }
    }
</script>
<style>
    .customGreen {
        color: #248f48 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/CreateBrand.vue